import {
  FETCH_POLICIES_CONFIG_ASYNC,
  FETCH_POLICIES_SCHEMA_ASYNC,
  SAVE_POLICIES_CONFIG_ASYNC,
} from './constants'

const initialState = {
  schema: [],
  loader: false,
  configLoader: false,
  configLoaded: false,
  saving: false,
  error: null,
  saveSuccess: false,
}

export default function emailEncryptionCompanyPoliciesReducer(state = initialState, action = {}) {
  switch (action.type) {
    case FETCH_POLICIES_SCHEMA_ASYNC.INITIATE:
      return { ...state, loader: true, error: null }
    case FETCH_POLICIES_SCHEMA_ASYNC.SUCCESS:
      return {
        ...state,
        loader: false,
        schema: Array.isArray(action.payload.data) ? action.payload.data : [],
      }
    case FETCH_POLICIES_SCHEMA_ASYNC.ERROR:
      return { ...state, loader: false, error: action.error }

    case FETCH_POLICIES_CONFIG_ASYNC.INITIATE:
      return { ...state, configLoader: true, error: null }
    case FETCH_POLICIES_CONFIG_ASYNC.SUCCESS:
      return { ...state, configLoader: false, configLoaded: true }
    case FETCH_POLICIES_CONFIG_ASYNC.ERROR:
      return { ...state, configLoader: false, configLoaded: false, error: action.error }

    case SAVE_POLICIES_CONFIG_ASYNC.INITIATE:
      return { ...state, saving: true, saveSuccess: false, error: null }
    case SAVE_POLICIES_CONFIG_ASYNC.SUCCESS:
      return { ...state, saving: false, saveSuccess: true }
    case SAVE_POLICIES_CONFIG_ASYNC.ERROR:
      return { ...state, saving: false, saveSuccess: false, error: action.error }
    default:
      return state
  }
}
